import { type FC, type ComponentProps } from "react";
import { TextArea } from "@root/shared/components/TextArea";
import { TextField } from "@root/shared/components/TextField";
import { RadioButton } from "@root/shared/components/RadioButton";
import { CheckboxAndText } from "@clientFrontend/features/publication/components/WelfareInputsCheckboxAndText";
import { InformationText } from "@root/shared/components/InformationText";
import { Label } from "@root/shared/components/Label";
import * as commonStyles from "@clientFrontend/features/publication/styles/styles.css";
import * as styles from "./styles.css";
import { type TransportationInputsProps } from "./type";

type Props = TransportationInputsProps & ComponentProps<typeof CheckboxAndText>;

export const Presentation: FC<Props> = ({
  text,
  value,
  checked,
  formNames,
  inputValues,
  errors,
  handleChangeCheckbox,
  handleInputChange,
  parentCheckboxId,
}) => {
  return (
    <div className={commonStyles.container}>
      <CheckboxAndText
        checked={checked}
        text={text}
        value={value}
        hasError={errors && Object.keys(errors).length > 0}
        onChange={(e) => handleChangeCheckbox(e.target.checked)}
        id={parentCheckboxId}
        name="work_requirement[welfares][]"
      />

      <div
        className={`${checked ? commonStyles.detailForm : commonStyles.detailFormDisabled} ${styles.detailFormColumn}`}
      >
        <section className={styles.fullWidthSection}>
          <h3 className={commonStyles.detailFormTitle}>
            支給額
            {checked && <Label theme="red">必須</Label>}
          </h3>
          <input
            type="hidden"
            id={formNames.transportationProvisionFullPaymentFlag}
            name={formNames.transportationProvisionFullPaymentFlag}
            value={inputValues?.transportationProvisionFullPaymentFlag ? "1" : "0"}
          />
          <div className={commonStyles.detailFormBodySingleBox}>
            <div className={styles.radioGroup}>
              <RadioButton
                id="transportation-provision-full-payment"
                name="transportation_provision_type"
                label="全額支給"
                checked={checked && !!inputValues?.transportationProvisionFullPaymentFlag}
                disabled={!checked}
                onChange={() => handleInputChange("transportationProvisionFullPaymentFlag", true)}
              />
              <div className={styles.radioWithInput}>
                <RadioButton
                  id="transportation-provision-amount-limit"
                  name="transportation_provision_type"
                  label="上限額あり"
                  checked={checked && inputValues?.transportationProvisionFullPaymentFlag === false}
                  disabled={!checked}
                  onChange={() =>
                    handleInputChange("transportationProvisionFullPaymentFlag", false)
                  }
                />
                <div className={styles.amountFieldWrapper}>
                  <div className={styles.amountFieldRow}>
                    <TextField
                      type="text"
                      className={styles.textAmountPer}
                      id={formNames.transportationProvisionPaymentAmountMax}
                      name={formNames.transportationProvisionPaymentAmountMax}
                      value={inputValues?.transportationProvisionPaymentAmountMax}
                      hasError={Boolean(errors?.transportationProvisionPaymentAmountMax)}
                      placeholder="入力してください"
                      disabled={!checked || !!inputValues?.transportationProvisionFullPaymentFlag}
                      onChange={(e) =>
                        handleInputChange("transportationProvisionPaymentAmountMax", e.target.value)
                      }
                    />
                    円
                  </div>
                  {errors?.transportationProvisionPaymentAmountMax && (
                    <InformationText
                      className={commonStyles.error}
                      isAlert
                      text={errors.transportationProvisionPaymentAmountMax}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className={commonStyles.detailFormSection}>
          <h3 className={commonStyles.detailFormTitle}>支給条件</h3>
          <div className={commonStyles.detailFormBodySingleBox}>
            <dl className={commonStyles.detailFormList}>
              <dd className={commonStyles.detailItem}>
                <TextArea
                  name={formNames.transportationProvisionPaymentConditions}
                  id={formNames.transportationProvisionPaymentConditions}
                  value={inputValues?.transportationProvisionPaymentConditions}
                  hasError={Boolean(errors?.transportationProvisionPaymentConditions)}
                  placeholder="入力してください"
                  size="small"
                  disabled={!checked}
                  onChange={(e) =>
                    handleInputChange("transportationProvisionPaymentConditions", e.target.value)
                  }
                />
              </dd>
            </dl>
          </div>
          {errors?.transportationProvisionPaymentConditions && (
            <InformationText
              className={commonStyles.error}
              isAlert
              text={errors.transportationProvisionPaymentConditions}
            />
          )}
        </section>
      </div>
    </div>
  );
};
